// extracted by mini-css-extract-plugin
export default {"breadcrumb":"Breadcrumb_breadcrumb__mu1n4","breadcrumb__item":"Breadcrumb_breadcrumb__item__6k7pg","breadcrumb__item--inactive":"Breadcrumb_breadcrumb__item--inactive__R5i1O"};